/**
 * Removes all HTML tags from a string value, leaving only plain text
 * @param value - The value to sanitize (can be string, null, undefined, or any type)
 * @returns Sanitized string with HTML tags removed, or original value if not a string
 * @example sanitizeHtml("<script>alert('xss')</script>John") // "John"
 * @example sanitizeHtml("<b>Dr.</b> Jane Smith") // "Dr. Jane Smith"
 */
export const sanitizeHtml = (value: any): any => {
	if (typeof value !== 'string') {
		return value;
	}

	return value.replace(/<[^>]*>/g, '').trim();
};

/**
 * Recursively sanitizes all string values in an object, removing HTML tags
 * @param data - Object with potential HTML in string fields
 * @returns New object with all string values sanitized
 * @example sanitizeObjectHtml({ name: "<b>John</b>", age: 30 }) // { name: "John", age: 30 }
 */
export const sanitizeObjectHtml = (data: any): any => {
	if (data === null || data === undefined) {
		return data;
	}

	if (typeof data === 'string') {
		return sanitizeHtml(data);
	}

	if (Array.isArray(data)) {
		return data.map((item) => sanitizeObjectHtml(item));
	}

	if (typeof data === 'object') {
		const sanitized: any = {};
		for (const key in data) {
			if (Object.prototype.hasOwnProperty.call(data, key)) {
				sanitized[key] = sanitizeObjectHtml(data[key]);
			}
		}
		return sanitized;
	}

	return data;
};
